/* Bar.tsx generated by @compiled/babel-plugin v0.28.8 */
import "./Bar.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { element } from '../../core/elements';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function createPathFromRoundedRect(x, y, width, height, radius) {
  if (radius === void 0) {
    radius = {};
  }
  const xEnd = x + width;
  const yEnd = y + height;
  const {
    topLeft = 0,
    topRight = 0,
    bottomLeft = 0,
    bottomRight = 0
  } = radius;
  return `M${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    L${xEnd - (topRight !== null && topRight !== void 0 ? topRight : 0)} ${y}
    A${topRight !== null && topRight !== void 0 ? topRight : 0} ${topRight !== null && topRight !== void 0 ? topRight : 0} 0 0 1 ${xEnd} ${y + (topRight !== null && topRight !== void 0 ? topRight : 0)}
    L${xEnd} ${yEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)}
    A${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} ${bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0} 0 0 1 ${xEnd - (bottomRight !== null && bottomRight !== void 0 ? bottomRight : 0)} ${yEnd}
    L${x + (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)} ${yEnd}
    A${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} ${bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0} 0 0 1 ${x} ${yEnd - (bottomLeft !== null && bottomLeft !== void 0 ? bottomLeft : 0)}
    L${x} ${y + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)}
    A${topLeft !== null && topLeft !== void 0 ? topLeft : 0} ${topLeft !== null && topLeft !== void 0 ? topLeft : 0} 0 0 1 ${x + (topLeft !== null && topLeft !== void 0 ? topLeft : 0)} ${y}
    Z`;
}
const barStyles = null;
export function PrivateBar(_ref) {
  let {
    datum,
    innerRef,
    ariaLabel,
    x,
    y,
    width,
    height,
    cornerRadius,
    fill,
    opacity
  } = _ref;
  const d = createPathFromRoundedRect(x, y, width, height, cornerRadius);
  return /*#__PURE__*/_jsx("path", {
    fill: fill,
    opacity: opacity,
    role: "img",
    "aria-label": ariaLabel,
    ref: innerRef,
    d: d,
    className: ax(["_v564g17y"])
  });
}
const _Bar = element(PrivateBar);
export { _Bar as Bar };